export const ascendingOrder = { 'order[order]': 'asc' } as const;
export const alphabeticallyOrderedNames = { 'order[name]': 'asc' } as const;
